import { inject, observer } from 'mobx-react';
import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import { withStateCard, Toast, ToastType, Button, CardTitle, CardContent, Card, Checkbox } from '../../Components';
import { MonografiaStore, MONOGRAFIA_STORE, ArquivoValidator, PalavrasChave, MonografiaModelValidator, PREPROJETO_STORE, PreProjetoStore } from '../../Store';
import { DepositoStore, DEPOSITO_STORE, SituacaoDoDeposito } from '../../Store/Deposito';
import { AgendamentoCard } from './Components/AgendamentoCard';
import { InfoProfessorCard } from './Components/InfoProfessorCard';
import { DepositoCard } from './Components/DepositoCard';
import { DepositoMessage } from './Components/DepositoMessage';
import { AlunoTccCard } from './Components/AlunoTccCard';
import { MonografiaNotFound } from './NotFound';
import { observe } from 'mobx';
import { apiState } from '../../Api';
import { GlobalErrorToast } from '../Shared/GlobalErrorToast';
import { RouteComponentProps } from 'react-router';
import { HelpButton } from '../Shared/HelpButton';
import Tutorial_Aluno from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Aluno.pdf";
import PreProjetoModal from './Components/PreProjetoModal';

interface IProps extends RouteComponentProps {
  [MONOGRAFIA_STORE]: MonografiaStore,
  [DEPOSITO_STORE]: DepositoStore,
  [PREPROJETO_STORE]: PreProjetoStore,
}

interface IState {
  apiState: number;
  loadingMessage?: string;
  success: boolean;
  isModalOpen: boolean;
}

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const ContainerWithState = withStateCard(Container);

const StyledHelpButton = styled(HelpButton)`
  margin-top: -41px;
  margin-left: 600px;
  border: 2px solid #fff;
  color: #fff;
`;

const StyledTutorialButton = styled(Button)`
  margin-left: auto;
`;

@inject(MONOGRAFIA_STORE, DEPOSITO_STORE, PREPROJETO_STORE)
@observer
export default class AlunoPage extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      apiState: apiState.loading,
      success: false,
      isModalOpen: false,
    };
  }

  getMonografia = () => {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    monografiaStore.getMonografiaDoAlunoAtual();
  }

  getPreProjeto = () => {
    const preProjetoStore = this.props[PREPROJETO_STORE]
    preProjetoStore.buscarPreProjetoDoAlunoAtual()
  }

  handleDepositoSubmit = () => {
    const depositoStore = this.props[DEPOSITO_STORE];

    const file = depositoStore.file;

    const errors = ArquivoValidator.getErrors({ file });
    depositoStore.setValidationError(errors);

    if (!errors) {
      depositoStore.setValidationError({})
      depositoStore.updateDepositoFile()
    }
  }

  handleDepositoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const depositoStore = this.props[DEPOSITO_STORE];
    depositoStore.changeDepositoFile(e.target.files && e.target.files[0]);
  }

  handleTipoDepositoChange = (value: any) => {
    const depositoStore = this.props[DEPOSITO_STORE];
    depositoStore.changeTipoDeposito(value);
  }

  onTituloChange = (event: ChangeEvent<HTMLInputElement>) => {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    monografiaStore.update('monografia', 'titulo', event.target.value);
  }

  onAutorizacaoChange = (value: any) => {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    monografiaStore.update('monografia', 'autorizacaoAluno', value);
  }

  onChipsRemoveElement = (element: string) => {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    let palavras = monografiaStore.monografia.palavrasChave;

    palavras = palavras.filter(e => e.palavraChave != element);
    monografiaStore.update('monografia', 'palavrasChave', palavras);
  }

  onChipsAddElement = (element: string) => {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    let palavras = [...monografiaStore.monografia.palavrasChave];
    if (element.trim() != '' && !palavras.filter(pc => pc.palavraChave == element).length) {
      palavras.push({ palavraChave: element } as PalavrasChave);
    }
    monografiaStore.update('monografia', 'palavrasChave', palavras);
  }

  onResumeClick = () => {
    window.open(Tutorial_Aluno);
  }

  salvarAlteracoes = async () => {
    const store = this.props[MONOGRAFIA_STORE];

    const error = MonografiaModelValidator.getErrors({ palavrasChave: store.monografia.palavrasChave, titulo: store.monografia.titulo });
    store.setValidationError(error);
    if (error) {
      return;
    }

    await store.editarMonografiaDoAluno();
    this.setState({ success: this.state.apiState == apiState.done });
  }

  componentDidMount = () => {
    this.getMonografia();
    this.getPreProjeto();

    observe(this.props[MONOGRAFIA_STORE], 'monografiaState', (change) => {
      if (this.state.apiState !== change.newValue)
        this.setState({ apiState: change.newValue, loadingMessage: undefined });
    });

    observe(this.props[DEPOSITO_STORE], 'depositoState', (change) => {
      if (this.state.apiState !== change.newValue)
        this.setState({ apiState: change.newValue, loadingMessage: 'Realizando depósito' });
    });
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  }

  closeModal = () => {
    this.setState({ isModalOpen: false });
  }

  render() {
    const {
      [MONOGRAFIA_STORE]: monografiaStore,
      [DEPOSITO_STORE]: depositoStore,
      [PREPROJETO_STORE]: preProjetoStore,
      history
    } = { ...this.props };

    const { monografia, monografiaValidationError } = monografiaStore;
    const { depositoValidationError, deposito, file } = depositoStore;
    const { preProjeto } = preProjetoStore;

    const { isModalOpen } = this.state;
    
    return (
      <>
        <StyledTutorialButton
          type="button" 
          color="primaryLightColor"
          onClick={this.onResumeClick}
        >
          Tutorial de Uso
        </StyledTutorialButton>
        <ContainerWithState
          state={this.state.apiState}
          loading={this.state.loadingMessage}
          notFound={MonografiaNotFound}
        >
          <GlobalErrorToast messages={depositoValidationError && depositoValidationError.global} />

          {this.state.success &&
            <Toast type={ToastType.success}> Alterações salvas </Toast>}

          {depositoValidationError && depositoValidationError.file &&
            <Toast type={ToastType.error}>{depositoValidationError.file}</Toast>}

          <DepositoMessage
            situacao={deposito && deposito.situacao}
            justificativa={deposito && deposito.justificativaDaReprovacao}
          />

          {monografia && monografia.professor &&
            <InfoProfessorCard professor={monografia.professor} />
          }

          {monografia && monografia.agendamento &&
            <AgendamentoCard agendamento={monografia.agendamento} />
          }

          {monografia && !monografia.aluno.alunoAtivo &&
            <Toast type={ToastType.warning}>
              Para ter se acesso à todas as funcionalidades, você deve primeiramente efetuar a rematrícula.
            </Toast>}

          <AlunoTccCard
            monografia={monografia}
            onTextChange={this.onTituloChange}
            onChipsAddElement={this.onChipsAddElement}
            onChipsRemoveElement={this.onChipsRemoveElement}
            salvarAlteracoes={this.salvarAlteracoes}
            validation={monografiaValidationError}
          />

          {monografia && monografia.aluno.alunoAtivo ?
            <>
              {![SituacaoDoDeposito.aprovado, SituacaoDoDeposito.pendente].includes(deposito.situacao) &&
                <DepositoCard
                  handleSubmit={this.handleDepositoSubmit}
                  validationError={depositoValidationError}
                  deposito={deposito}
                  file={file}
                  handleChange={this.handleDepositoChange}
                  handleTipoChange={this.handleTipoDepositoChange}
                />
              }
            </> :
            <Card>
              <CardTitle>Depósito</CardTitle>
              <CardContent>Você esta impossibilitado de enviar depósito.</CardContent>
            </Card>
          }

        {preProjeto &&
          <Card>
            <CardTitle>Pré-Projeto</CardTitle>
            <CardContent 
              style={{textDecoration: 'underline', cursor: 'pointer' }} 
              onClick={this.openModal}
            >
              Clique aqui para ver mais sobre o pré-projeto.
            </CardContent>
          </Card>
        }
          {isModalOpen && <PreProjetoModal preprojeto={preProjeto} onClose={this.closeModal} />}
          <Checkbox
              label='Autorizo a publicação do meu trabalho, caso preenchidas todas as condições e recomendado pelo orientador'
              checked={Boolean(monografia.autorizacaoAluno)}
              onChange={(e: any) => { this.onAutorizacaoChange(e.target.checked) }}
          />

          <Button onClick={() => {
            if ([SituacaoDoDeposito.inexistente, SituacaoDoDeposito.reprovado].includes(deposito.situacao)) {
              this.handleDepositoSubmit();
            }
            this.salvarAlteracoes();
          }}>
            Salvar Alterações
          </Button>
          <Button disabled={monografia && !monografia.aluno.alunoAtivo} onClick={() => history.push('/aluno/orientacoes')}>
            Ir para orientações do professor
          </Button>
          <StyledHelpButton>
            {monografia && monografia.aluno.alunoAtivo 
              ? 'Solicite aqui ao seu Orientador todas as orientações cientificas que desejar, para aprimorar o seu TCC.'
              : 'Seu acesso ao chat esta desativado.'
            }
          </StyledHelpButton>
        </ContainerWithState>
      </>
    );
  }
}